/*
  本文へ自動で用語の札を当てない語 (日常語として使うことの方が多い語)。
  辞書の別名の側で止めるので、同じ用語の別の名前 (例 image の Docker イメージの英名) は今までどおり当たる。
  用語集のページには何も影響しない。止めるのは本文への自動の当て込みだけ。
  足すのは「本文では日常語の意味で使われ、辞書の定義 (ある章の意味) と食い違う語」だけ。難しいから隠す、には使わない。
*/
export const NO_AUTOLINK_EVERYDAY_WORDS: ReadonlySet<string> = new Set([
  "関連",
  "イメージ",
  "設計",
  "評価",
  "判断",
  "形式",
  "振り返り",
  "集計",
  "処理",
  "目的",
  "検証",
  "掛け算",
  "セット",
  "テスト",
]);
